import {toast} from "react-toastify";

export const actionCreators = {
    showError: (message) => async () => {
        toast.error(message);
    },
    showSuccess: (message) => async () => {
        toast.success(message);
    },
};